import { useEffect, useState } from "react";
import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import RenderMathQuestion from "../../../../../../shared/components/RenderMathQuestion/RenderMathQuestion";
import { optionLables } from "../..";
import "./QuestionCard.css";
import QuestionHeader from "../../Layout/QuestionHeader/QuestionHeader";
import { updateQuestionStatus } from "../../../../../../redux/exam/examSlice";

const QuestionCard = () => {
  const { selector, dispatch } = useAppHooks();
  const state = selector((state) => state.examSlice);

  const [integerAnswer, setIntegerAnswer] = useState("");

  const currentLang = state?.currentLang || "en";
const question = state?.question?.[0];
  // Check if we are in gamified practice mode (instant feedback)
  const isPracticeGamified =
    state?.testDetails?.practiceMode === "practice" &&
    state?.testDetails?.gamificationOn === true;

  // Mark current question as active/current
  useEffect(() => {
    if (question?.qid) {
      dispatch(
        updateQuestionStatus({
          qid: question.qid,
          makeCurrent: true,
        })
      );
    }
  }, [dispatch, question?.qid]);
if (!question) {
  return null;
}
  const handleOptionClick = (optionId) => {
  const currentQid = question.qid;
  const answerType = Number(question?.answer_type_id);

  // MULTIPLE CORRECT
  if (answerType === 2) {
    const existingSelections = Array.isArray(currentQ.selectedOption)
      ? currentQ.selectedOption
      : [];

    const updatedSelections = existingSelections.includes(optionId)
      ? existingSelections.filter((id) => id !== optionId)
      : [...existingSelections, optionId];

    dispatch(
      updateQuestionStatus({
        qid: currentQid,
        selectedOption: updatedSelections,
      })
    );
  }
// SINGLE CORRECT
  else {
    dispatch(
      updateQuestionStatus({
        qid: currentQid,
        selectedOption: optionId,
      })
    );
  }
};

  const handleIntegerInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setIntegerAnswer(value);
      dispatch(
        updateQuestionStatus({
          qid: question.qid,
          integerAnswer: value,
        })
      );
    }
  };

  const currentQ =
  state.questionsData?.find(
    (q) => q.qid === question?.qid
  ) || {};
let optionsArray = [];

if (Array.isArray(question?.option) && question.option.length > 0) {
  optionsArray = question.option;
} else {
  const rawOption =
    currentLang === "en"
      ? question?.eng_option
      : question?.h_option;

  if (rawOption) {
    try {
      optionsArray = JSON.parse(rawOption);
    } catch (e) {
      console.log("Option parse error", e);
      optionsArray = [];
    }
  }
}
  return (
    <div className="exam__question_card">
      <QuestionHeader /> 

      <div className="exam__question_card__question">
        {question && (
          <RenderMathQuestion
            question={
              currentLang === "en"
                ? question.q_text
                : question.q_text_hindi
            }
          />
        )}
      </div>

      <div className="exam__question_card__options">
      {[1, 2].includes(Number(question?.answer_type_id)) ? (
            optionsArray.map((opt, index) => {
            const isMultiple = Number(question?.answer_type_id) === 2;
           const isSelected = isMultiple
      ? Array.isArray(currentQ.selectedOption) &&
      currentQ.selectedOption.includes(opt.option_id)
     : currentQ.selectedOption === opt.option_id;
            const isCorrectOption = opt.is_correct === 1;

            // In gamified practice mode, show immediate feedback after selection
            // const showResult = isPracticeGamified && currentQ?.selectedOption;
            const showResult =
  isPracticeGamified &&
  (isMultiple
    ? Array.isArray(currentQ.selectedOption) &&
      currentQ.selectedOption.length > 0
    : currentQ.selectedOption);

            let optionClass = "";
            let labelClass = "";

            if (showResult) {
              if (isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
              } else if (isSelected && !isCorrectOption) {
                optionClass = "option-wrong";
                labelClass = "label-wrong";
              } else if (!isSelected && isCorrectOption) {
                optionClass = "option-correct";
                labelClass = "label-correct";
              }
            } else if (isSelected) {
              optionClass = "selected";
              labelClass = "selected-label";
            }

            return (
              <div
                key={opt.option_id}
                className={`exam__question_card__option ${optionClass}`}
                onClick={() => handleOptionClick(opt.option_id)}
              >
                <span
                  className={`exam__question_card__option_label ${
                    labelClass || "not-selected-label"
                  }`}
                >
                  {optionLables[index]}
                </span>

             <RenderMathQuestion
  question={
    currentLang === "en"
      ? opt.option
      : opt.option_hindi ?? opt.option
  }
/>
              </div>
            );
          })
        ) :Number( question?.answer_type_id )=== 3 ? (
          <div className="exam__question_card__integer_input">
            <input
              type="text"
              value={currentQ?.integerAnswer || ""}
              onChange={handleIntegerInputChange}
              placeholder="Enter an integer"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default QuestionCard;